import React from 'react'
import Banner from "./components/banner/Banner";
import Contact from "./components/contact/Contact";
import Counters from "./components/counters/Counters";
import Features from "./components/features/Features";
import FooterBottom from "./components/footer/FooterBottom";
import Projects from "./components/projects/Projects";
import Resume from "./components/resume/Resume";


const Home = () => {
  return (
    <div>
      <div className="max-w-screen-xl mx-auto px-4">
        <Banner />
        <Counters />
        <Features />
        <Projects />
        <Resume />
        {/* <Testimonial /> */}
        <Contact />
        <FooterBottom />
      </div>
    </div>
  )
}

export default Home
